




































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {$, WholeCollection, Collection} from 'simpli-web-sdk'
import Carga from '../../model/resource/Carga'
import Auditoria from '../../model/resource/Auditoria'
import AuditoriaMotivo from '../../model/resource/AuditoriaMotivo'
import AuditoriaObservacao from '../../model/resource/AuditoriaObservacao'
import EmailAuditoria from '../../model/resource/EmailAuditoria'
import * as Helper from '../../helpers'
import moment from 'moment'
import EmailNivel from '@/model/resource/EmailNivel'
import {Getter} from 'vuex-class'
import Responsavel from '@/model/resource/Responsavel'

@Component
export default class ItAudit extends Vue {
  @Prop({type: Object, required: true}) value!: Carga
  @Prop({type: Boolean, default: false}) isModal!: boolean
  @Getter('auth/responsavel') user!: Responsavel

  carga = new Carga()
  auditoria = new Auditoria()

  auditApproved: boolean | null = null

  allAuditoriaMotivo = new WholeCollection(AuditoriaMotivo)
  allAuditoriaObservacao = new Collection(AuditoriaObservacao)
  allAuditoriaEmail = new WholeCollection(EmailAuditoria)
  allEmailNivel = new WholeCollection(EmailNivel)
  Helper = Helper

  get showAuditReason() {
    return this.auditApproved === false
  }

  get showAuditEmail() {
      return this.auditApproved === false && this.allAuditoriaEmail.items.length > 0
  }

  get showAuditSubmit() {
    return this.auditApproved === true
      ||
      // se escolheu um motivo para reprovar
      (this.auditoria.motivo && this.auditoria.motivo.$id)
      ||
      this.auditoria.observacao.texto
  }

  get motivoResource() {
    return this.auditoria.motivo
  }

  set motivoResource(val: AuditoriaMotivo | null) {
    this.auditoria.motivo = val ? this.allAuditoriaMotivo.get(val.$id) : null
  }

  get emailResource() {
      return this.auditoria.emailAuditoria
  }

  set emailResource(val: EmailAuditoria | null) {
      this.auditoria.emailAuditoria = val ? this.allAuditoriaEmail.get(val.$id) : null
  }

  get emailNivel() {
    return this.auditoria.emailAuditoria &&
    this.auditoria.emailAuditoria.emailAuditoriaNivel && this.auditoria.emailAuditoria.emailAuditoriaNivel.emailNivel ?
        this.auditoria.emailAuditoria.emailAuditoriaNivel.emailNivel : new EmailNivel()
  }

  set emailNivel(val: EmailNivel) {
    if (this.auditoria.emailAuditoria && this.auditoria.emailAuditoria.emailAuditoriaNivel
        && this.auditoria.emailAuditoria.emailAuditoriaNivel.emailNivel) {
      this.auditoria.emailAuditoria.emailAuditoriaNivel.emailNivel = val
    }
  }

  @Watch('value', {immediate: true, deep: true})
  async valueEvent(carga: Carga) {
    this.carga = carga
    this.auditoria = this.carga.auditoria.clone()
    this.auditoria.carga = this.carga
  }

  @Watch('auditApproved')
  auditApprovedEvent(val: boolean | null) {
    return this.auditoria.conforme = val
  }

  @Watch('auditoria.observacao.replicarCTE')
  auditReplicarCTE(val: boolean) {
    this.auditoria.replicarCTE = val
  }

  @Watch('auditoria.emailAuditoria')
  async populateNivel() {
    if (this.emailResource) {
      this.$await.init('getNivel')
      this.allEmailNivel.endpoint = `/user/email-auditoria/grupo-nivel/${this.emailResource.idEmailAuditoriaPk}`
      await this.allEmailNivel.query()
      this.$await.done('getNivel')
    }
  }

  aprove() {
    if (this.auditApproved === true) {
      this.auditApproved = null
    } else {
      this.auditApproved = true
    }
  }

  decline() {
    if (this.auditApproved === false) {
      this.auditApproved = null
    } else {
      this.auditApproved = false
    }
  }

  async changeDataCanhoto() {
    if (this.auditoria.dataCanhoto) {
      const dataCanhoto = moment(this.auditoria.dataCanhoto)

      if (dataCanhoto.hour() === 0 && dataCanhoto.minute() === 0) {
        this.auditoria.dataCanhoto = dataCanhoto.set('hour', 23).set('minute', 59).format()
      }
    }

    await this.auditoria.changeDataCanhoto(this.auditoria)
    this.carga.auditoria.dataCanhoto = this.auditoria.dataCanhoto
  }

  async persistAuditoria() {
    if (this.auditoria.dataCanhoto) {
      const dataCanhoto = moment(this.auditoria.dataCanhoto)

      if (dataCanhoto.hour() === 0 && dataCanhoto.minute() === 0) {
        this.auditoria.dataCanhoto = dataCanhoto.set('hour', 23).set('minute', 59).format()
      }
    }

    if (this.auditApproved !== null) {
      await this.auditoria.validate()
      await this.auditoria.persistAuditoria(this.auditoria)
    } else {
      this.auditoria.observacao.idCargaFk = this.auditoria.idCargaFk
      await this.auditoria.observacao.persistAuditoriaObservacao(this.auditoria.observacao)
    }
    await this.loadInfo()
    Helper.success('system.success.persist')

    this.$emit('persist')
  }

  async mounted() {
    await this.loadInfo()
  }

  async loadInfo() {

    this.allAuditoriaEmail.endpoint = `/user/email-auditoria/active-grupos/${this.user.$id}`
    this.auditApproved = null
    await this.allAuditoriaEmail.query()
    await this.allAuditoriaMotivo.query()
    await this.allAuditoriaObservacao.query({idCarga: this.value.$id})

  }
}
